var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-btn"},[_c('v-btn',{staticClass:"mt-5 px-5 secondary--text social-g",attrs:{"href":_vm.googleLink,"type":"submit","block":"","color":"white"}},[_c('v-img',{attrs:{"height":24,"max-width":24}}),_c('div',{staticClass:"pr-5 flex-grow-1"},[_vm._v(" Google "+_vm._s(_vm.$t('登入'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }